// Layout
import { StatusIndicatorStatus } from '../../layout/elements/StatusIndicator';

export enum PLCCardType {
  input = 'input',
  output = 'output',
  analog = 'analog',
}

export interface PLCCardItem {
  status?: StatusIndicatorStatus;
  text?: string;
  showStatusIndicator?: boolean;
  value?: string;
  number?: string | number;
}

export interface PLCCardProps {
  className?: string;
  testId?: string;
  type: PLCCardType;
  text: string;
  items?: PLCCardItem[];
}
